import React, { useCallback } from 'react';
import { getIn } from 'formik';

import Checkbox from '../../checkbox';
import { FieldElementPropTypes } from '../propTypes';

const CheckboxField = ({
  field: { id, name, label, mode, value, optional, onChange: customOnChange, checkedValue, uncheckedValue, ...props },
  ctx: { setFieldValue, setFieldTouched, touched, errors, classes }
}) => {
  const hasCustomValues = checkedValue !== undefined;
  const onChange = useCallback(
    (e) => {
      const checked = e.target.checked;
      setFieldValue(name || id, hasCustomValues ? (checked ? checkedValue : uncheckedValue) : checked);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(e, checked);
      }
    },
    [setFieldTouched, setFieldValue, id, name, hasCustomValues, checkedValue, uncheckedValue]
  );
  return (
    <Checkbox
      key={id}
      id={id}
      name={name || id}
      value={hasCustomValues ? value === checkedValue : !!value}
      mode={mode}
      label={label}
      classes={classes[id]}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) ? getIn(errors, name || id) : undefined}
      {...props}
    />
  );
};

CheckboxField.propTypes = FieldElementPropTypes;

export default CheckboxField;
